import { observer } from "mobx-react";
import { localeRegistry } from "../../internationalization/SupportedLocales";
import { useStores } from "../../stores/useStores";
import { Select } from "@radix-ui/themes";
import useTheme from "../radix/useTheme";

const OrgSupportedLocaleSelector = observer(
  (props: {
    disabled: boolean;
    handleSelectorChange: (value: string) => void;
    className?: string;
    value: string;
    [key: string]: any;
  }) => {
    const { i18nStore } = useStores();
    const { disabled, handleSelectorChange } = props;
    const radixTheme = useTheme();

    return (
      <Select.Root
        {...props}
        disabled={disabled}
        onValueChange={handleSelectorChange}
        value={props.value}
      >
        <Select.Trigger>{props.value}</Select.Trigger>
        <Select.Content
          container={radixTheme.portalContainer?.current}
          translate={"no"}
          position={"popper"}
        >
          {i18nStore.organizationSupportedLocales.map((locale) => {
            return (
              <Select.Item key={locale} value={locale}>
                {localeRegistry[locale]._englishName}
              </Select.Item>
            );
          })}
        </Select.Content>
      </Select.Root>
    );
  },
);

export default OrgSupportedLocaleSelector;
